import { useNavigate } from "react-router-dom";

type TGoToTargetOptions = {
  /** Replace the current history entry instead of pushing a new one. */
  replace?: boolean;
};

/**
 * Returns a navigator that routes to a post-auth target: in-app routes (starting with "/") go
 * through React Router's navigate to keep the SPA context, while external URLs trigger a full
 * page load via location. Shared by the passkey login flow, the login verify form, and the
 * Google (Cognito) callback.
 */
export const useGoToTarget = () => {
  const navigate = useNavigate();

  return (target: string, options?: TGoToTargetOptions) => {
    if (target.startsWith("/")) {
      navigate(target, options);
    } else if (options?.replace) {
      globalThis.location.replace(target);
    } else {
      globalThis.location.assign(target);
    }
  };
};
